export const VOUCHER_PAYMENT_INTERNAL_FILTER = {
  INTERNAL_FILTER_GET_REQUEST_SUCCESS: 'INTERNAL_FILTER_GET_REQUEST_SUCCESS',
};
